import React, { useEffect } from 'react'
import Navbar from 'src/components/Navbar/Navbar'
import ViewNewsContent from 'src/components/News/ViewsNewsContent/ViewsNewsContent'
import Footer from 'src/components/Footer/Footer'

const ViewNewsPage = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  return (
    <>
      <Navbar />
      <ViewNewsContent />
      <Footer />
    </>
  )
}

export default ViewNewsPage
